const firebaseConfig = {

    apiKey: "AIzaSyD6zpsn69hNSV7UMy9ZCIToedUG6X9RfcI",
  
    authDomain: "watch-shop-app.firebaseapp.com",
  
    projectId: "watch-shop-app",
  
    storageBucket: "watch-shop-app.appspot.com",
  
    messagingSenderId: "244254264309",
  
    appId: "1:244254264309:web:a5b5464d7eea804d542ebc"
  
  };
export default firebaseConfig;  